@if (isVisible() && campaign(); as activeCampaign) {
  <section class="feedback-widget" aria-label="Toolhive feedback">
    <div class="feedback-widget__header">
      <div>
        <p class="feedback-widget__eyebrow">Toolhive feedback</p>
        <h3>{{ activeCampaign.name || 'How was your experience?' }}</h3>
      </div>
    </div>

    <p class="feedback-widget__description">
      {{
        activeCampaign.description ||
          'Rate your overall Toolhive experience and share optional feedback so we can improve the product.'
      }}
    </p>

    <div class="feedback-widget__scores" role="group" aria-label="Feedback score">
      @for (score of scores; track score) {
        <button
          type="button"
          class="feedback-widget__score"
          [class.feedback-widget__score--selected]="selectedScore() === score"
          [attr.aria-pressed]="selectedScore() === score"
          (click)="selectScore(score)">
          {{ score }}
        </button>
      }
    </div>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Additional comments</mat-label>
      <textarea
        matInput
        rows="4"
        [value]="comment()"
        [attr.maxlength]="maxCommentLength"
        (input)="updateComment($event)"></textarea>
      <mat-hint align="end">{{ remainingCharacters() }} characters left</mat-hint>
    </mat-form-field>

    <div class="feedback-widget__meta">
      <p class="feedback-widget__disclaimer">
        Your rating and comment are used to improve Toolhive. Please avoid sharing personal or
        sensitive data in comments.
      </p>
    </div>

    <div class="feedback-widget__actions">
      <button type="button" mat-button (click)="dontShowAgain()" [disabled]="isSubmitting()">
        Don't show again
      </button>
      <button type="button" mat-button (click)="skip()" [disabled]="isSubmitting()">Skip</button>
      <button type="button" mat-flat-button (click)="submit()" [disabled]="!canSubmit()">
        @if (isSubmitting()) {
          <mat-spinner diameter="18"></mat-spinner>
        } @else {
          <span>Submit</span>
        }
      </button>
    </div>
  </section>
}
